import React, {useState} from 'react';
import classNames from "classnames";


import AudioButton from "../common/AudioButton/AudioButton";
import ConfirmButton from "../common/ConfirmButton/ConfirmButton";
import { ImageCard } from "../common/ImageCard/ImageCard";
import { Controls } from "../../Controls";

import { ChooseProps } from "./Choose.type";

import './styles.scss';

export const Choose: React.FC<ChooseProps> = ({
  type,
  images,
  audio,
  controls,
}) => {
  const [selectedAudio, setSelectedAudio] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [optionIsSelected, setOptionIsSelected] = useState<boolean>(false);
  const [selectedIsCorrect, setSelectedIsCorrect] = useState<boolean>(false);
  // const [selectedIsCorrectAfterCheck, setSelectedIsCorrectAfterCheck] = useState<boolean | null>(null);
  const [checkIsDone, setCheckIsDone] = useState<boolean>(false);


  const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState<string>('');

  const chooseAudio = type === "Audio";
  const chooseImage = type === "Image";

  // console.log("selectedAudio", selectedAudio)
  // console.log("selectedImage", selectedImage)

  const correctAudio = audio.find(item => item.correct)?.path;
  const correctImage = images.find(item => item.correct)?.path;

  const onImageSelect = (path: string) => {
    setSelectedImage(path);
    setOptionIsSelected(true);
    //
    const isCorrect = path === correctImage;
    setSelectedIsCorrect(isCorrect);
  }

  const onAudioSelect = (path: string) => {
    setSelectedAudio(path);
    setOptionIsSelected(true);
    // setIsPlayingExternal(true)

    const isCorrect = path === correctAudio;
    setSelectedIsCorrect(isCorrect);
  }

  // const onConfirmClick = () => {
  //   const isCorrect = path === correctImage;
  //   setSelectedIsCorrect(isCorrect);
  // }

    const resetSelection = () => {
    setSelectedImage(null);
    setOptionIsSelected(false);
    setSelectedIsCorrect(false);
    setCheckIsDone(false);
  };

  // const onAfterCheck = ({ isCorrect, isChecked }: {isCorrect: boolean, isChecked: boolean}) => {
  //   setSelectedIsCorrectAfterCheck(isCorrect);
  // }


  const { handlePrev, handleNext, currentIndex, lastItemIndex } = controls;

  const handleNextClick = () => {
    setCheckIsDone(false);
    setOptionIsSelected(false);
    // setIsPlaying(false);
    handleNext();
  }

  return (
    <>
    <div className={classNames(`ActivityContainer Choose${type}`, {
      "isRadioForAudio": chooseAudio,
      "CheckIsDone": checkIsDone,
    })}>
      <div className="ImagesContainer">
        {!!images?.length && images.map(image =>
          <ImageCard
            key={image.path}
            path={image.path}
            isRadio={chooseImage}
            isSelected={selectedImage === image.path}
            onSelect={() => chooseImage && onImageSelect(image.path)}
            selectedIsCorrect={selectedIsCorrect}
            checkIsDone={checkIsDone}
          />
        )}
      </div>
      <div className="AudioContainer">
        {!!audio.length && audio.map(item => {
          const isSelected = selectedAudio === item.path;

          return (
            <AudioButton
              key={item.path}
              src={item.path}
              isRadio={chooseAudio}
              currentlyPlayingAudio={currentlyPlayingAudio}
              setCurrentlyPlayingAudio={setCurrentlyPlayingAudio}
              isSelected={isSelected}
              onSelect={() => chooseAudio && onAudioSelect(item.path)}
              selectedIsCorrect={isSelected && checkIsDone && !!selectedAudio && selectedIsCorrect}
              checkIsDone={checkIsDone}
              currentIndex={currentIndex}
            />
          )
        })}
      </div>
      <div className="ConfirmButtonContainer">
        <ConfirmButton
          // onConfirm={onConfirmClick}
          optionIsSelected={optionIsSelected}
          // isActive={activeConfirmButton}
          selectedIsCorrect={selectedIsCorrect}
          // onAfterCheck={() => onAfterCheck}
          setCheckIsDone={setCheckIsDone}
          resetSelection={resetSelection}
          checkIsDone={checkIsDone}
          showCorrectStatus={checkIsDone}
        />
      </div>
    </div>
    <Controls handlePrev={handlePrev} handleNext={handleNextClick} currentIndex={currentIndex} lastItemIndex={lastItemIndex}/>
    </>
  );
};
